export default __webpack_public_path__ + "static/media/What we do-eachpage-APICreation&Mgmt.853d45fe.png";